import React from 'react';
import "../../main/main.css";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import paybackLogoImg from "./img/paybackLogo.png";
import paybackCardImg from "./img/paybackCard.png";
import { useActionListener } from 'redux-action-listener-hook';
import {isCardCode, isCouponCode} from "./util";
import {addErrorAlert, addPaybackCoupon, setPaybackCustomer} from "../../redux/actions";
import {useSelector} from "react-redux";

const ScanCustomerCard = (props) => {
    let cashierMode = useSelector(state => state.rootReducer.cashierMode);
    let payback = useSelector(state => state.rootReducer.payback);
    useActionListener('SCANNER_DETECTED', (dispatch, action) => {
        console.log({useActionListener: action});
        const scannedCode = action.payload;
        if(isCardCode(scannedCode)){
            dispatch(setPaybackCustomer(scannedCode));
        }else if(isCouponCode(scannedCode)){
            if(payback.coupons.indexOf(scannedCode) !== -1){
                dispatch(addErrorAlert('Coupon is already in the transaction!'));
            }else{
                dispatch(addPaybackCoupon(scannedCode));
            }
        }else{
            dispatch(addErrorAlert('Not a proper Payback card or coupon number!'));
        }
    });

    let paymentButton = (
        <div style={{marginBottom: "1rem"}} onClick={e => {
            props.paybackInputDone();
        }}>
            <Button
                buttonStyle={{minWidth: "21.43rem"}}
                type="button"
                className={"largeButton yellowButton"}
                name={<Translate id="Proceed"/>}
            />
        </div>
    );
    let enterCardCodeButton = (
        <div style={{marginBottom: "1rem"}} onClick={e => {
            if(payback.customer === false) {
                props.enterCardCode();
            }else {
                props.enterCouponCode(payback.coupons);
            }
        }}>
            <Button buttonStyle={{minWidth: "21.43rem"}} type="button" className={"largeButton blueBorderButton"} name={<Translate id="Add Payback manually"/>}/>
        </div>
    );

    let orLine = (
        <div style={{
            width: "21.43rem",
            margin: "auto"
        }}>
            <div className={"diagonalLine"} style={{
                float: "left",
                marginTop: "2.86rem"
            }}/>
            <span className={"coloredText"} style={{
                textTransform: "uppercase",
                fontStyle: "italic",
                fontSize: "1.43rem"
            }}>
                <Translate id="or"/>
            </span>
            <div className={"diagonalLine"} style={{
                float: "right",
                marginTop: "0.71rem"
            }}/>
        </div>
    );

    let contentInMode;
    if(cashierMode){
        contentInMode = <>
            <img src={paybackLogoImg} style={{
                width: 120,
                alignSelf: "center"
            }} alt="paybackLogoImg"/>
            <div style={{
                fontSize: "1.14rem",
                width: "60%",
                margin: "2.14rem auto 0"
            }}>
                <Translate id={"Our customers can find the customer card and the eCoupons in the Payback app"}/>
            </div>
            <div style={{
                flexGrow: "1",
                alignContent: "center"
            }}>
                {orLine}
            </div>
            {enterCardCodeButton}
            {paymentButton}
        </>;
    }else{
        contentInMode = <>
            <img src={paybackCardImg} style={{
                maxWidth: "90%",
                maxHeight: "18.57rem",
                display: "block",
                margin: "0 auto"
            }} alt="scanPaybackCard"/>
            <div style={{
                fontSize: "1.14rem",
                width: "70%",
                margin: "3.57rem auto 1.43rem"
            }}>
                <Translate id={"You can find your customer card and the eCoupons in the Payback app"}/>
            </div>
            <div style={{
                flexGrow: 1
            }}/>
            {paymentButton}
        </>;
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            top: 54,
            bottom: 0,
            left: 0,
            right: 0
        }}>
            <span style={{
                whiteSpace: "pre-wrap",
                marginBottom: "0.36rem"
            }} className={"boldUppercaseText"}>
                <Translate id={"Do you collect Payback points?"}/>
            </span>
            <span className={"boldUppercaseText"}>
                <Translate id={"Scan now!"}/>
            </span>
            <div style={{
                "marginBottom": "1.43rem"
            }}/>
            { contentInMode }
        </div>
    );
}

export default ScanCustomerCard;